<div class="form-section">
  <h3 class="section-title">{{ "employee.vcard.sectionTitle" | translate }}</h3>
  <div class="links-list">
    <div
      *ngFor="let row of notes.controls; let i = index; trackBy: trackByIndex"
      class="links-form-row"
      [formGroup]="$any(row)"
    >
      <div class="fields-stack">
        <mat-form-field appearance="outline" class="note-field">
          <mat-label>{{ "employee.vcard.noteLabel" | translate }}</mat-label>
          <textarea
            matInput
            formControlName="note"
            rows="2"
            [placeholder]="'employee.vcard.notePlaceholder' | translate"
          ></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="period-field" subscriptSizing="dynamic">
          <mat-label>{{ "employee.vcard.validityLabel" | translate }}</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate formControlName="validFrom" />
            <input matEndDate formControlName="validTo" />
          </mat-date-range-input>
          <button
            *ngIf="hasDates(i)"
            mat-icon-button
            matSuffix
            type="button"
            class="clear-period-btn"
            [attr.aria-label]="'employee.vcard.clearPeriod' | translate"
            [matTooltip]="'employee.vcard.clearPeriod' | translate"
            (click)="clearPeriod(i)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker
            #picker
            [calendarHeaderComponent]="calendarRangeHeader"
          ></mat-date-range-picker>
          <mat-hint *ngIf="!hasDates(i)">{{ "employee.vcard.indefinite" | translate }}</mat-hint>
        </mat-form-field>

        <mat-error
          *ngIf="errorStateMatcher.submitAttempted && getErrorKey(i) as errorKey"
          class="row-error"
        >
          <ng-container [ngSwitch]="errorKey">
            <span *ngSwitchCase="'dateRangeInvalid'">{{ "dateRangeInvalid" | translate }}</span>
            <span *ngSwitchCase="'overlap'">{{ "employee.vcard.overlap" | translate }}</span>
            <span *ngSwitchCase="'multipleIndefinite'">{{
              "employee.vcard.onlyOneIndefinite" | translate
            }}</span>
          </ng-container>
        </mat-error>
      </div>

      <div class="delete-wrapper">
        <button mat-icon-button type="button" (click)="removeNote(i)">
          <mat-icon class="delete-btn">delete_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="add-link-action">
    <button mat-stroked-button type="button" (click)="addNote()">
      <mat-icon>add</mat-icon>
      <span>{{ "add" | translate }}</span>
    </button>
  </div>
</div>
